module.exports = __webpack_public_path__ + "images/bookmark@1x.png?cbd2b74e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookmark@1x.png
// module id = 606
// module chunks = 7